import { FULFILLMENT_METHOD_DEFAULT } from './constants';

export const parseFulfillmentMethod = (supportedFulfillmentMethods, fulfillmentMethod) => {
  if (!fulfillmentMethod || !supportedFulfillmentMethods.length) {
    return FULFILLMENT_METHOD_DEFAULT;
  }

  const normalisedFulfillmentMethod = fulfillmentMethod.toUpperCase();
  return supportedFulfillmentMethods.includes(normalisedFulfillmentMethod)
    ? normalisedFulfillmentMethod
    : FULFILLMENT_METHOD_DEFAULT;
};

export const getFulfillmentMethodParam = (fulfillmentMethod) =>
  fulfillmentMethod === FULFILLMENT_METHOD_DEFAULT
    ? null
    : `fulfillment_method=${fulfillmentMethod}`;
